export const DEFAULT_TIME_CLOCK_TIME_ZONE = 'America/Chicago';

const MINUTE_MS = 60 * 1000;

const atMinute = (value = new Date()) => {
  const date = new Date(value);
  date.setSeconds(0, 0);
  return date;
};

export class TimeClockError extends Error {
  constructor(code, message, fields = {}) {
    super(message);
    this.name = 'TimeClockError';
    this.code = code;
    this.fields = fields;
  }
}

export function toMinuteIso(value) {
  return value ? atMinute(value).toISOString() : null;
}

export function formatMinutes(value) {
  const minutes = Math.max(0, Number(value) || 0);
  const hours = Math.floor(minutes / 60);
  const remainder = Math.round(minutes % 60);
  return `${hours}h ${String(remainder).padStart(2, '0')}m`;
}

export function formatTime(value, timeZone = DEFAULT_TIME_CLOCK_TIME_ZONE) {
  if (!value) return 'Active';
  return new Intl.DateTimeFormat('en-US', {
    timeZone,
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(value));
}

export function formatDate(value, timeZone = DEFAULT_TIME_CLOCK_TIME_ZONE) {
  if (!value) return '—';
  const normalized = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00Z` : value;
  return new Intl.DateTimeFormat('en-US', {
    timeZone,
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(normalized));
}

export function entryMinutes(entry, now = new Date()) {
  if (
    entry?.totalMinutes !== null
    && entry?.totalMinutes !== undefined
    && Number.isFinite(Number(entry.totalMinutes))
  ) return Number(entry.totalMinutes);
  if (!entry?.startedAt) return 0;
  const end = entry.endedAt ? new Date(entry.endedAt) : now;
  return Math.max(0, Math.floor((end.getTime() - new Date(entry.startedAt).getTime()) / MINUTE_MS));
}

export function timeTotals(record = {}) {
  const totalPaidMinutes = Math.max(0, Number(record.paidMinutes) || 0);
  const overtimeMinutes = Math.min(
    totalPaidMinutes,
    Math.max(0, Number(record.overtimeMinutes) || 0),
  );

  return {
    regularMinutes: totalPaidMinutes - overtimeMinutes,
    overtimeMinutes,
    totalPaidMinutes,
  };
}
